/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerCallbacks } from "../../../shared/context/PlayerCallbacksContext";
import { usePlayerComponents } from "../../../shared/context/PlayerComponentsContext";
import { usePlayerTranslation } from "../../../shared/context/PlayerTranslationContext";
import BackIcon from "../../../shared/icons/navigation/Arrow_left.svg";
import { PlayerMediaState } from "../../../shared/types";

import "./AssetInfoOverlay.scss";

export interface AssetInfoOverlayProps {
  media: PlayerMediaState;
  isVisible: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const AssetInfoOverlay = ({
  media,
  isVisible,
  onClick,
}: AssetInfoOverlayProps) => {
  const { onClosePlayer } = usePlayerCallbacks();
  const { t } = usePlayerTranslation();
  const { Button } = usePlayerComponents();
  const closeLabel = t("PLAYER_TOOLTIP_CLOSE_PLAYER");

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClick) {
      onClick(e);
    }
  };

  const goBack = () => {
    onClosePlayer?.();
  };

  if (!media || !media.Media) {
    return null;
  }

  return isVisible ? (
    <div className="AssetInfoOverlay__Background" onClick={handleClick}>
      <div className="AssetInfoOverlay__Header">
        <span className="AssetInfoOverlay__Header--backIcon">
          <Button
            variant="tertiary"
            onClick={goBack}
            tooltip={closeLabel}
            tooltipAlign="left"
            tooltipOffset={60}
            aria-label={closeLabel}
            iconOnly
          >
            <BackIcon aria-hidden="true" focusable="false" />
          </Button>
        </span>
      </div>
      <div className="AssetInfoOverlay__Container">
        <div className="AssetInfoOverlay__Content">
          <h1 className="AssetInfoOverlay__Title">{media.Media.Title}</h1>
          <div
            className="AssetInfoOverlay__Description"
            dangerouslySetInnerHTML={{
              __html: media?.Media.Description || "",
            }}
          />
        </div>
      </div>
    </div>
  ) : null;
};

export default AssetInfoOverlay;
